import {useCallback, useEffect, useRef, useState} from "react";
import OneSelectUI from "../inputs/one-select";

// Кастомный хук для авто-высоты textarea
const useAutoHeight = (value) => {
  const textareaRef = useRef(null);

  const adjustHeight = useCallback(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, []);

  useEffect(() => {
    adjustHeight();
  }, [value, adjustHeight]);

  return textareaRef;
};

// Модифицированная строка таблицы
export default function CheckElement({checkEl, setCheckEl, deleteCheckElement, availableB24Fields}) {
  const nameRef = useAutoHeight(checkEl.name);
  const descRef = useAutoHeight(checkEl.description);
  const exampleRef = useAutoHeight(checkEl.example);
  console.log(availableB24Fields, checkEl, availableB24Fields.filter(el => el.system_name === checkEl.mark_field_system_name)[0])
  return (
    <tr className={'check_element'}>
      <td><textarea
        ref={nameRef}
        value={checkEl.name}
        onChange={e => {
          const updatedEl = {...checkEl, name: e.target.value};
          setCheckEl(updatedEl);
        }}
        placeholder={'Укажите название для элемента чек-листа'}

      /></td>

      <td><textarea
        ref={descRef}
        value={checkEl.description}
        onChange={e => {
          const updatedEl = {...checkEl, description: e.target.value};
          setCheckEl(updatedEl);
        }}
        placeholder={'Укажите описание элемента чек-листа. Здесь необходимо указать критерий проверки'}
      /></td>

      <td><textarea
        ref={exampleRef}
        value={checkEl.example}
        onChange={e => {
          const updatedEl = {...checkEl, example: e.target.value};
          setCheckEl(updatedEl);
        }}
        placeholder={'Укажите пример'}
      /></td>
      <td>
        <OneSelectUI
          title={'Флаг'}
          selectionOptions={availableB24Fields.filter(el => el.field_type === 'float' || el.field_type === 'string').map(el => {return {value: el.system_name, label: el.name}})}
          selectedOption={availableB24Fields.filter(el => el.system_name === checkEl.mark_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
          setSelectedOption={el => {
            const updatedEl = {...checkEl, mark_field_system_name: el.value};
            setCheckEl(updatedEl);
          }}
          placeholder={'Выберите...'}
        />
        <OneSelectUI
          title={'Комментарий'}
          selectionOptions={availableB24Fields.filter(el => el.field_type === 'string').map(el => {return {value: el.system_name, label: el.name}})}
          selectedOption={availableB24Fields.filter(el => el.system_name === checkEl.comment_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
          setSelectedOption={el => {
            const updatedEl = {...checkEl, comment_field_system_name: el.value};
            setCheckEl(updatedEl);
          }}
          placeholder={'Выберите...'}
        />
      </td>
      <td className={'check_element_delete'}
          onClick={() => deleteCheckElement(checkEl.id)}>
        ✖
      </td>
    </tr>
  )
}